export default {
  marketPlace: 'السوق التجارية',
  shareTrading: 'مناقلة الأسهم',
  allMarketActivities: 'جميع سجلات السوق',
  allShareActivities: 'جميع أنشطة الأسهم',
  imInterested: 'أنا مهتم',
  viewsellinfo: 'عرض معلومات البيع',
  sharesNumber: 'عدد الأسهم',
  pricePerShare: 'سعر السهم',
  totalCost: 'التكلفة الإجمالية',
  sellInformation: 'معلومات البيع',
  shareOwnership: 'ملكية الأسهم',
  email: 'البريد الإلكتروني',
  phoneNumber: 'رقم الهاتف',
  equityClass: 'فئة الأسهم',
  numberOfShares: 'عدد الأسهم',
  transactionType: 'نوع المعاملة',
  sell: 'بيع',
  total: 'الإجمالي',
  listing: 'العرض',
  highestOfferedPrice: 'أعلى سعر مقدم',
  submit: 'إرسال',
  cancel: 'إلغاء',
  counterOffer: 'العرض المقدم',
  confirm: 'تأكيد',
  confirmModalContent:
    'لا يمكن إلغاء هذه العملية بعد قبول البائع. إذا أظهرت اهتمامًا فهذا يعني أنك موافق على السعر وعدد الأسهم',
  areYouSure: 'هل أنت متأكد؟',
};
